import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "departments",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "ayt-departments" */ "./components"),
      import(
        /* webpackChunkName: "departments" */ "AdminSettings/routes/Departments/modules/DepartmentsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "accountDepartments",
        reducer,
      });
      return component;
    })
  ),
});
